import { render, staticRenderFns } from "./BreadcrumbSlot.vue?vue&type=template&id=633f7066"
import script from "./BreadcrumbSlot.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports